"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) {
    var _a;
    return ({
        wrapper: function (_a) {
            var error = _a.error;
            return ({
                '&:focus-within': {
                    borderColor: "".concat(error ? theme.colors.maroon400 : theme.colors.gray500)
                },
                background: theme.colors.white,
                transition: 'all 0.2s ease-in-out'
            });
        },
        groupDescriptionWrapper: {
            width: '100%'
        },
        legendAndTooltipWrapper: {
            display: 'flex',
            alignItems: 'center'
        },
        errorTextWrapper: {
            alignItems: 'center',
            display: 'flex',
            padding: ['2px', '0px']
        },
        errorIconWrapper: {
            display: 'flex',
            flexGrow: 0,
            flexShrink: 0,
            marginRight: '4px'
        },
        inputWrapper: {
            minHeight: '48px',
            padding: ['12px', '0px'],
            width: '100%',
            '&.nested': {
                paddingLeft: "calc(".concat(theme.spacing('medium'), " + ").concat(theme.spacing('xlarge'), ")")
            }
        },
        twoColumn: (_a = {},
            _a["@media only screen and (min-width: ".concat(theme.breakpoints.medium, "px)")] = {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                '& $inputWrapper': {
                    width: '50%'
                }
            },
            _a)
    });
});
